import { useCompetitionDivisionListQuery } from '../queries';
import { BaseFormState } from '~/types/BaseFormState';
import { Input, SelectProps } from '~/components/Input';
import { ForwardedRef, forwardRef } from 'react';

type Props<TFormState extends BaseFormState> = Omit<SelectProps<TFormState>, 'options'> & {
  competitionId: number;
};

function CompetitionDivisionSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { competitionId, ...rest } = props;
  const { data, isLoading } = useCompetitionDivisionListQuery({ competition: competitionId, page_size: 999 });

  return (
    <Input.Select
      placeholder={props.placeholder ?? 'Välj lagtävlingsdivision'}
      aria-label={props['aria-label'] ?? 'Lagtävlingsdivision'}
      options={data?.results.map(d => [d.name, d.id]) ?? []}
      disabled={isLoading}
      ref={ref}
      {...rest}
    />
  );
}

export const CompetitionDivisionSelect = forwardRef(CompetitionDivisionSelectElement) as <
  TFormState extends BaseFormState
>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof CompetitionDivisionSelectElement>;
